<script setup lang="ts">
import { computed } from 'vue';
import { BRAND_MAP } from '@/enums';
import useMatestoreStore from '@/store/matestoreStore';
import useGlobalStore from '@/store/globalStore';
import { NIconSVG } from '@nio-fe/icon';
import IconALPS from '@/assets/images/icon_logo_alps.svg';
import IconNIO from '@/assets/images/icon_logo_nio_app.svg';
import IconFY from '@/assets/images/icon_logo_fy.svg';
const BRAND_ICON_MAP = {
  alps: IconALPS,
  nio: IconNIO,
  fy: IconFY,
};
interface HistoryTabItemProps {
  name: string;
  route: any;
}
const props = defineProps<HistoryTabItemProps>();
const microStore = useMatestoreStore();
const globalStore = useGlobalStore();
const tabName = computed(() => {
  if (!props.name) {
    return microStore.findMicroApp(props.route.microName)?.label;
  }
  return props.name;
});
const brandIconName = computed(() => {
  if (globalStore.getAvailableBrands().length < 2) {
    return null;
  }
  if (new RegExp(`^(${Object.keys(BRAND_MAP).join('|')})`).test(props.name)) {
    return null;
  } else {
    const brandQueryReg = new RegExp(
      `brand=(${Object.keys(BRAND_ICON_MAP).join('|')})`
    );
    if (props.route.fullPath.match(brandQueryReg)) {
      const brand = props.route.fullPath.match(brandQueryReg)[1];
      if (brand) {
        return brand;
      }
    }
    return null;
  }
});
</script>

<template>
  <span class="history-tab-name"
    ><img
      :src="BRAND_ICON_MAP[brandIconName]"
      alt="BRAND_ICON"
      class="brand-icon"
      v-if="brandIconName"
    />
    {{ tabName }}</span
  >
</template>

<style scoped lang="scss">
.history-tab-name {
  display: inline-flex;
  align-items: center;
  .brand-icon {
    margin-right: 4px;
    width: 16px;
    height: 16px;
  }
}
</style>
